import { z } from "zod";
import { DocumentSchema } from "./base.schema";

/**
 * Individual chat message schema
 * Represents a single message within a chat conversation
 */
export const ChatMessageSchema = DocumentSchema.extend({
  /** User who sent this message */
  sender_uid: z.string().optional().describe("ID of the user who sent the message"),

  /** Chat conversation this message belongs to */
  chat_id: z.string().optional().describe("ID of the chat conversation"),

  /** Text content of the message */
  text: z.string().optional().describe("Text content of the message"),

  /** Image URL if message contains an image (NOT YET IMPLEMENTED) */
  image: z.url().optional().describe("URL of image attachment - feature not yet available"),

  /** When the message was originally sent */
  timestamp: z.date().optional().describe("When the message was sent"),

  /** When the message was received by the recipient */
  received_timestamp: z.date().optional().describe("When the message was received"),

  /** When the message was read by the recipient */
  read_timestamp: z.date().optional().describe("When the message was read"),
});

/**
 * Frontend chat message schema - excludes unimplemented features
 * Use this for client-side validation until image support is ready
 */
export const ChatMessageInputSchema = ChatMessageSchema.omit({ id: true, image: true }).refine(
  (data) => data.text && data.text.trim().length > 0,
  { message: "Message text is required", path: ["text"] }
);

export type ChatMessage = z.infer<typeof ChatMessageSchema>;
export type ChatMessageInput = z.infer<typeof ChatMessageInputSchema>;
